import React from 'react'
import PropTypes from 'prop-types'

const IconDownload = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M10.69 11.38v-.54-5.35c0-.88.54-1.49 1.3-1.49s1.32.61 1.32 1.5v5.84l.36-.31c.68-.7 1.35-1.4 2.04-2.09.58-.58 1.35-.6 1.88-.07.55.54.55 1.36-.03 1.97a688.02 688.02 0 0 1-4.6 4.7c-.6.62-1.34.61-1.94 0a891.38 891.38 0 0 1-4.59-4.71c-.56-.58-.57-1.39-.05-1.93.54-.56 1.31-.55 1.9.05L10.3 11l.39.38M12.02 20h-5.7c-.63 0-1.09-.42-1.26-1.08-.16-.6.02-1.28.49-1.62.23-.16.54-.28.81-.28 3.77-.02 7.53-.02 11.3-.01.8 0 1.35.67 1.34 1.52-.01.85-.58 1.46-1.38 1.47h-5.6" />
  </svg>
)

IconDownload.propTypes = {
  className: PropTypes.string.isRequired,
}

export default IconDownload
